/* IndexedDB queue for offline diary entries (with photo blobs) */
const DB_NAME = "ceramixa-offline";
const STORE = "diary_queue";

function openDb() {
    return new Promise((resolve, reject) => {
        const req = indexedDB.open(DB_NAME, 1);
        req.onupgradeneeded = () => {
            const db = req.result;
            if (!db.objectStoreNames.contains(STORE)) {
                const s = db.createObjectStore(STORE, { keyPath: "localId" });
                s.createIndex("jobId", "jobId");
                s.createIndex("seq", "seq");
            }
        };
        req.onsuccess = () => resolve(req.result);
        req.onerror = () => reject(req.error);
    });
}

function tx(db, mode, fn) {
    return new Promise((resolve, reject) => {
        const t = db.transaction(STORE, mode);
        const store = t.objectStore(STORE);
        let result;
        try { result = fn(store); } catch (e) { reject(e); return; }
        t.oncomplete = () => resolve(result?.result ?? result);
        t.onerror = () => reject(t.error);
    });
}

const reqToPromise = (r) => new Promise((res, rej) => { r.onsuccess = () => res(r.result); r.onerror = () => rej(r.error); });

export async function dbPut(item) {
    const db = await openDb();
    await tx(db, "readwrite", (s) => s.put(item));
}

export async function dbGet(localId) {
    const db = await openDb();
    const t = db.transaction(STORE, "readonly");
    return reqToPromise(t.objectStore(STORE).get(localId));
}

export async function dbAll() {
    const db = await openDb();
    const t = db.transaction(STORE, "readonly");
    const all = await reqToPromise(t.objectStore(STORE).getAll());
    return all.sort((a, b) => a.seq - b.seq);
}

export async function dbDelete(localId) {
    const db = await openDb();
    await tx(db, "readwrite", (s) => s.delete(localId));
}

export const hasIndexedDb = () => typeof indexedDB !== "undefined";
